import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';
import { Navigate } from 'react-router-dom';
import { useMode } from '../hooks/useMode';
import { getLandingRoute } from '../util/landingRoute';

export const IntroductionRedirect = () => {
  const mode = useMode();
  const consultation = useSelector((state: RootState) => state.consultation);

  return <Navigate to={getLandingRoute(mode, consultation)} />;
};
